import LoginPage from "./LoginPage";
import MainPage from "./MainPage";
import Dashboard from "./MainPage/Dashboard";
import Operation from "./MainPage/Operation";
import Report from "./MainPage/Report";
import List from "./MainPage/List";
import SettingPage from "./MainPage/Setting/SettingPage";
import NotFoundPage from "./NotFoundPage";
import {
  Navigate,
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
import Table from "../Components/Table/Table";
import Chart from "../Components/Chart";
import { ToastContainer } from "react-toastify";

import Factorprint from "../Components/Printpage/Factorprint";
import Assistant from "./AssistantPage";
import Bill from "../Components/Assistant/Bill/Bill";
import Category from "../Components/Assistant/Category/Category";
import AddNewReport from "../Components/Assistant/ReportAssistant/AddNewReport/AddNewReport";
import DashboardAssistant from "../Components/Assistant/Dashboard/DashboardAssistant";
import DocumentForm from "../Components/Assistant/DocumentForm";
import MainFormBuilder from "../Components/Assistant/MainFormMaker/MainFormBuilder";
import LevelForm from "../Components/Assistant/LevelForm/LevelForm";
import DeleteLevelForm from "../Components/Assistant/DeleteLevelForm/DeleteLevelForm";
import ReportAssistant from "../Components/Assistant/ReportAssistant/ReportAssistant";
import AssistantForm from "../Components/Assistant/AssistantForm/AssistantForm";
import Form from "../Components/Form";
import FormKpiView from "../Components/Form/FormKpiView";
import ForgetPassword from "../Components/LoginForgetPassword/ForgetPassword";
import FormKpiBuilder from "../Components/Form/FormKpiBuilder";
import AdminReport from "../Components/AdminReport/AdminReport";

export const PrintDataContext = React.createContext();
export const SetPrintDataContext = React.createContext();

export default function Pages() {
  const [isAuth, setIsAuth] = useState(
    sessionStorage.getItem("isAuth") === "true" ? true : false
  );
  const [factorData, setFactorData] = useState(0);
  useEffect(() => {
    sessionStorage.setItem("isAuth", isAuth);
  }, [isAuth]);

  return (
    <Router>
      <ToastContainer
        position="bottom-left"
        autoClose={2500}
        hideProgressBar={true}
        newestOnTop={false}
        theme="colored"
        closeOnClick
        rtl
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
      />
      <SetPrintDataContext.Provider value={setFactorData}>
        <PrintDataContext.Provider value={factorData}>
          <Routes>
            <Route path="/ForgetPassword" element={<ForgetPassword />} />
            <Route
              exact
              path="/"
              element={
                isAuth ? (
                  <MainPage setIsAuth={setIsAuth} sidebarMode={"normal"} />
                ) : (
                  <Navigate to={"/Login"} />
                )
              }
            >
              <Route path="/factorprint" element={<Factorprint />} />
              <Route path="/adminReport" element={<AdminReport />} />
              <Route path="Dashboard" element={<Dashboard />} />
              <Route path="openKpiPage" element={<FormKpiView />} />
              <Route path="FormKpiBuilder" element={<FormKpiBuilder />} />
              <Route path="Operation/:id" element={<Operation />} />
              <Route path="Report" element={<Report />}>
                <Route path=":id" element={<Chart />} />
              </Route>

              <Route path="List" element={<List />}>
                <Route path=":id" element={<Table />} />
              </Route>

              <Route path="Setting" element={<SettingPage />} />
              <Route path="/" element={<Dashboard />} />
            </Route>
            <Route
              path="/assistant"
              element={
                isAuth ? (
                  <Assistant setIsAuth={setIsAuth} />
                ) : (
                  <Navigate to={"/Login"} />
                )
              }
            >
              <Route path="category" element={<Category />}>
                <Route path=":id/:level/:code" element={<Category />} />
              </Route>

              <Route path="report" element={<AddNewReport />} />
              <Route path="report/:id" element={<ReportAssistant />} />
              <Route path="addNewReport/:id" element={<AddNewReport />} />
              <Route path="document-form" element={<DocumentForm />} />
              <Route path="new-form/:id" element={<MainFormBuilder />} />
              <Route path="AssistantForm/:id" element={<Form />} />
              <Route path="level-form" element={<LevelForm />} />
              <Route path="bill" element={<Bill />} />
              <Route path="delete-level" element={<DeleteLevelForm />} />

              <Route
                path="dashboardAssistant"
                element={<DashboardAssistant />}
              />
            </Route>
            <Route
              path="/Login"
              element={
                isAuth ? (
                  <Navigate to={"/Dashboard"} />
                ) : (
                  <LoginPage isAuthenticated={[isAuth, setIsAuth]} />
                )
              }
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </PrintDataContext.Provider>
      </SetPrintDataContext.Provider>
    </Router>
  );
}
